import React, {useEffect, useState} from "react";
import "./Scenes.css";
import Row from "react-bootstrap/Row";
import Scene from "./Scene";
import LoadingIcon from "components/dasboardv3/components/Partials/LoadingIcon/LoadingIcon";
import {Alert} from "react-bootstrap";

window.isLoadingScenes = false;

function Scenes({bond, reloadTimestamp, devicesById}) {
    const [scenesById, setScenesById] = useState({});
    const [isLoadingScenes, setIsLoadingScenes] = useState(false);
    const [loadError, setLoadError] = useState(null);

    async function reloadScenes() {
        setIsLoadingScenes(true);
        let response = await bond.get("/scenes")
        let scenesIds = Object.keys(response).filter(key => !key.startsWith("_"));

        let allScenes = {};
        for (let i = 0; i < scenesIds.length; i += 10) {
            const scenesGroups = [];
            scenesGroups.push(scenesIds.slice(i, i + 10));
            const scenesRequests = scenesGroups.map(group => Promise.all(group.map(async sceneId => {
                const data = await bond.get(`/scenes/${sceneId}`);
                return {sceneId, data};
            })));
            const scenesData = await Promise.all(scenesRequests);
            for (let i = 0; i < scenesData.length; i++) {
                for (let j = 0; j < scenesData[i].length; j++) {
                    const scene = scenesData[i][j];
                    allScenes[scene.sceneId] = scene.data
                }
            }
        }
        setScenesById(allScenes);
        setIsLoadingScenes(false);
    }

    useEffect(() => {
        if (reloadTimestamp && !window.isLoadingScenes) {
            setIsLoadingScenes(true);
            window.isLoadingScenes = true;
            reloadScenes().then(() => {
                window.isLoadingScenes = false
            }).catch(() => {
                setLoadError(["Unable to load scenes!", "Check if bond firmware version is updated."]);
            }).finally(() => {
                window.isLoadingScenes = false
                setIsLoadingScenes(false);
            });
        }
    }, [reloadTimestamp]);

    return (<div>
        {isLoadingScenes ? <div className={"d-flex justify-content-center m-2"}><LoadingIcon/></div> : (<>
            <Row xs={1} md={2} className={"devicesRow"}>
                {Object.keys(scenesById).map(sceneId => (<Scene key={sceneId} sceneId={sceneId}
                                                                sceneData={scenesById[sceneId]} bond={bond}/>))}
            </Row>
        </>)}
        {loadError ? <Alert variant="warning" onClose={() => setLoadError(null)} dismissible>
            <p>{loadError[0]}</p>
            <p>{loadError[1]}</p>
        </Alert> : <></>}
    </div>);
}

export default Scenes;
